<template>

  <div class="login_block renew2_flex" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="login_block__01">
      <div class="login_mail">
        <h3>メールアドレスで登録する</h3>
        <div class="renew2_flex id">
          <p class="title">ログインID</p>
          <div class="input">
            <el-input v-model="mailRegister.email" type="email" autocomplete name="mail-link-input"
              placeholder="メールアドレスを入力してください" :disabled="loginEmailSending"></el-input>
          </div>
        </div>
        <div class="renew2_flex pw">
          <p class="title">パスワード</p>
          <div>
            <div class="input"><el-input v-model="mailRegister.passwd" type="password" autocomplete
                name="mail-link-input" placeholder="パスワードを入力してください" :disabled="loginEmailSending"></el-input></div>
          </div>
        </div>
        <div class="renew2_flex pw">
          <p class="title">確認パスワード</p>
          <div>
            <div class="input"><el-input v-model="mailRegister.passwdConfirm" type="password" autocomplete
                name="mail-link-input" placeholder="確認用のパスワードを入力してください" :disabled="loginEmailSending"></el-input></div>
          </div>
        </div>
        <p class="pw_memo">※半角英小文字・大文字・数字を組合せて8〜20字で入力してください。記号も使用できます。</p>
        <p style="text-align: center;"><el-checkbox v-model="isAgree">同意する</el-checkbox></p>
        <button type="button" class="btn" id="email-login-account-dialog"
          @click="registerIdPw()"><!----><!----><span>送信する</span></button>
        <p class="memo">メールアドレス入力後、アドレス確認のためメールをお送りします。</p>
      </div>
    </div>
    <div class="login_block__02">
      <div class="login_sns">
        <h3>他のサービスIDを利用して<br class="renew2_sp">登録する</h3>
        <p style="text-align: center;"><el-checkbox v-model="isAgree">同意する</el-checkbox></p>
        <ul class="renew2_flex sns_list">
          <li class="sns_list__item">
            <button class="renew2_flex renew2_sp_flex" @click="signInGoogle">
              <img src="/static/renew2_img/google.png" alt="Google">
              <p>Googleで登録</p>
            </button>
          </li>
          <li class="sns_list__item" v-if="$site.appFlag != 'b' && getMode != 'production1'">
            <button class="renew2_flex renew2_sp_flex" @click="signInLine">
              <img src="/static/renew2_img/line_icon.jpeg" alt="LINE">
              <p>LINEで登録</p>
            </button>
          </li>
          <li class="sns_list__item">
            <button class="renew2_flex renew2_sp_flex" @click="signInApple">
              <img src="/static/renew2_img/appleinc.png" alt="Apple">
              <p>AppleIDで登録</p>
            </button>
          </li>
          <li class="sns_list__item" v-if="getMode != 'production'">
            <button class="renew2_flex renew2_sp_flex" @click="$firebase.signInFacebook();">
              <img src="/static/renew2_img/facebook.png" alt="Facebook">
              <p>Facebookで登録</p>
            </button>
          </li>
        </ul>

        <div class="sns_list__link" v-if="$site.appFlag != 'b'">
          <h3>メールに登録リンクを送る</h3>
          <div class="renew2_flex maillink">
            <div class="input"><el-input v-model="mailRegister.email" type="email" autocomplete name="mail-link-input"
                placeholder="メールアドレスを入力してください" :disabled="loginEmailSending"></el-input></div>
          </div>
          <p style="text-align: center;"><el-checkbox v-model="isAgree">同意する</el-checkbox></p>
          <el-button type="primary" id="email-login-account-dialog" class="maillink-btn" :plain="isPlainButton"
            @click="mailSubmit" v-loading="loginEmailSending">メールでリンクを送る</el-button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      fullscreenLoading: false,
      isAgree: true,
      mailRegister: {
        email: ''
      },
      mailRegisterRules: {
        email: [
          {
            required: true,
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: 'メールアドレスをいれてね',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
  },
  methods: {
    resetloginEmail: function () {
      this.mailRegister.email = ''
      this.loginEmailSending = false
      // this.$refs['mailRegisterForm'].resetFields()
    },
    signInGoogle: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInGoogle()
    },
    signInLine: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInLine()
    },
    signInApple: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      this.$firebase.signInApple()
    },
    mailSubmit: function () {
      const app = this
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      // this.$refs['mailRegisterForm'].validate(async valid => {
      //   if (!valid) {
      //     return
      //   }
      app.$firebase.signInEmail(app.mailRegister.email)
      app.loginEmailSending = true
      // })
    },
    isInValidEmail: function (mailStr) {
      const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
      return !reg.test(mailStr)
    },
    isValidPassword: function (password) {
      if (password.length >= 8 && password.length <= 20) {
        return false
      } else {
        return true
      }
      const reg = new RegExp(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/)
      return !reg.test(password)
    },
    registerIdPw: function () {
      if (!this.isAgree) {
        this.$message({
          message: '利用規約と個人情報の扱いに同意してください。',
          type: 'error'
        })
        return
      }
      if (this.isInValidEmail(this.mailRegister.email)) {
        this.$message({
          message: 'ログインIDのメールアドレスを正しく入力してください',
          type: 'error'
        })
        return
      }
      if (this.isValidPassword(this.mailRegister.passwd)) {
        this.$message({
          message: 'パスワードを正しい形式で入力してください。※半角英小文字・大文字・数字を組合せて8〜20字で入力してください。記号も使用できます。',
          type: 'error'
        })
        return
      }
      if (this.mailRegister.passwd != this.mailRegister.passwdConfirm) {
        this.$message({
          message: 'パスワードと確認パスワードが一致していません。',
          type: 'error'
        })
        return
      }
      this.$firebase.signOnEmailPasswd(this.mailRegister.email, this.mailRegister.passwd)
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>
